import { IconButton } from '@material-ui/core';
import T from 'components/common/text/T';
import DOMPurify from 'dompurify';
import { IMainNotification } from 'lib/types/utilTypes';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
interface NoticeModalProps {
  language: string;
  notice?: IMainNotification;
  onClickNoRepeat: () => void;
  onClickNextAction: (type: 'SOFTWARE' | 'GENERAL') => void;
}

function NoticeModal({ language, notice, onClickNoRepeat, onClickNextAction }: NoticeModalProps) {
  const sanitizer = DOMPurify.sanitize;

  const { t } = useTranslation();

  useEffect(() => {
    console.log('HDS] notice ________ ', notice);
  }, [notice]);

  if (!notice) return <></>;
  return (
    <StyledPatientToothTooltip data-component-name="NoticeModal">
      <div className="NoticeModal__wrapper">
        <div className="NoticeModal__title_box">
          <div className="NoticeModal__title">{notice?.title}</div>
          <div className="NoticeModal__date">
            {language === 'en'
              ? moment.unix(notice?.publishDate).locale(language).format('MMM DD, YYYY')
              : moment.unix(notice?.publishDate).locale(language).format('YYYY.MM.DD')}
          </div>
        </div>
        <div className="NoticeModal__contents_box">
          <div className="NoticeModal__contents_row">
            {/* <div className="NoticeModal__contents_title_box">
              <div className="NoticeModal__contents_title_icon"></div>
              <div className="NoticeModal__contents_title"></div>
            </div> */}
            <div className="NoticeModal__contents">
              <div dangerouslySetInnerHTML={{ __html: sanitizer(notice?.content) }}></div>
            </div>
          </div>
        </div>
        <div className="NoticeModal__button_box">
          <IconButton
            className="NoticeModal__button noRepeat"
            onClick={() => {
              onClickNoRepeat();
            }}
          >
            <span>
              <T>NOTICE_NOREPEAT</T>
            </span>
          </IconButton>
          <IconButton
            className="NoticeModal__button moveApp"
            onClick={() => {
              onClickNextAction(notice?.type);
            }}
          >
            <span>{notice?.type === 'SOFTWARE' ? <T>NOTICE_GO_TO_APP</T> : <T>GLOBAL_OK</T>}</span>
          </IconButton>
        </div>
      </div>
    </StyledPatientToothTooltip>
  );
}

const StyledPatientToothTooltip = styled.div<{}>`
  .NoticeModal__wrapper {
    background-color: #ffffff;
    width: 550px;
    /* padding: 20px; */
    border-radius: 10px;
    .NoticeModal__title_box {
      text-align: center;
      padding: 30px 0;
      .NoticeModal__title {
        font-size: 20px;
        color: #303030;
      }
      .NoticeModal__date {
        font-size: 14px;
        color: #888;
      }
    }
    .NoticeModal__contents_box {
      width: 500px;
      height: 280px;
      overflow-y: overlay;
      margin: 0 auto;
      border: 1px solid #e1e1e1;
      border-radius: 5px;
      padding: 20px;
      .NoticeModal__contents_row {
        .NoticeModal__contents_title_box {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .NoticeModal__contents_title_icon {
            width: 14px;
            height: 14px;
            background-color: #303030;
            margin-right: 5px;
          }
          .NoticeModal__contents_title {
            font-size: 16px;
            font-weight: 500;
          }
        }
      }
      .NoticeModal__contents {
        line-height: 20px;
        margin-bottom: 20px;
      }
    }

    .NoticeModal__button_box {
      padding: 30px 25px;
      display: flex;
      justify-content: space-between;
      .NoticeModal__button {
        width: 245px;
        height: 40px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.noRepeat {
          background-color: #a5a5a5;
        }
        &.moveApp {
          background-color: #00a4e3;
        }
        span {
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
`;

export default React.memo(NoticeModal);
